import { render, staticRenderFns } from "./MainContent.vue?vue&type=template&id=032e826e&"
import script from "./MainContent.vue?vue&type=script&lang=js&"
export * from "./MainContent.vue?vue&type=script&lang=js&"
import style0 from "./MainContent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports